export default "__VITE_ASSET__CCeAW_Dm__ 100w";